import { useState } from "react";
import { useEffect } from "react";
import useRolesByEmail from "../../../../custom-hooks/useRolesByEmail";
import { errorHandler } from "../../../../helpers/errorHandler";
import { Loader } from "../../../../UI/Loaders/Loaders";

export default function UpdateUserRole({ dataRecord, onCloseModal }) {
  const [roles, setRoles] = useState([]);
  const [error, setError] = useState("");
  const {
    action,
    data: {
      user: { id, email },
      rolesData,
    },
  } = dataRecord;

  const {
    data: currentlyAssignedRoles,
    status,
    error: rolesError,
  } = useRolesByEmail({
    email,
    refreshData: Date.now(),
  });

  useEffect(() => {
    // This section sets the default roles state to the roles the person currently has.
    let rolesToBeAssigned = [];
    currentlyAssignedRoles &&
      currentlyAssignedRoles.roles.forEach((role) => {
        rolesToBeAssigned.push(role);
      });
    setRoles(rolesToBeAssigned);
    // eslint-disable-next-line
  }, [currentlyAssignedRoles]);

  const updateUserRoles = (e) => {
    e.preventDefault();
    if (!roles.length) {
      setError("You have to select at least one role!");
      const element = document.getElementById("roles-error-element");
      element.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
      return;
    }

    const data = {
      userID: id,
      roleName: roles,
    };
    onCloseModal();
    setTimeout(() => {
      action(data);
    }, 100);
  };

  const onChange = (e, name) => {
    setError("");
    if (e.target.checked) {
      const newRoles = [...roles, name];
      setRoles(newRoles);
    } else {
      const newRoles = roles.filter((role) => role !== name);
      setRoles(newRoles);
    }
  };

  if (status === "loading")
    return (
      <Loader centered="true" text={`Loading user's current role(s)...`} />
    );

  return (
    <div className="" style={{ height: "70vh", overflowY: "scroll" }}>
      <h3 className="Modal__title p-b-2 text-center">Update User Roles</h3>

      <span id="roles-error-element">
        {error && (
          <h5 className="error-element p-b-2 text-center font-weight-bold">
            {error}
          </h5>
        )}
      </span>
      <div className="p-l-2">
        <small className="error-element p-b-2">
          Roles currently assigned to this user
        </small>
        {rolesError ? (
          <p className="p-l-0 p-b-1 text-center">{errorHandler(rolesError)}</p>
        ) : (
          <ol type="1" className="p-l-0 p-b-1">
            {currentlyAssignedRoles &&
              currentlyAssignedRoles.roles &&
              currentlyAssignedRoles.roles.length &&
              currentlyAssignedRoles.roles.map((role, _id) => (
                <li key={_id}>{role}</li>
              ))}
          </ol>
        )}
      </div>
      <form onSubmit={updateUserRoles} className="p-l-2">
        <small className="error-element p-t-2">
          Tick all the roles to be assigned to this user
        </small>
        {rolesData &&
          rolesData.length &&
          rolesData.map((role) => {
            const { name, id } = role;
            const isChecked = roles.find((role) =>
              role === name ? true : false
            );
            return (
              <div key={id}>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultChecked={isChecked}
                    onClick={(e) => onChange(e, name)} // Please keep this as onClick, don't change to onChange
                  />
                  <label className="form-check-label">{name}</label>
                </div>
              </div>
            );
          })}

        <div className="Form__action-buttons m-t-1">
          <button
            type="button"
            className="btn zoom-element btn login-btn m-0 mr-auto"
            onClick={onCloseModal}
          >
            <i className="fas fa-times-circle"></i>
            &nbsp; Cancel
          </button>
          <button
            type="submit"
            className="btn zoom-element btn login-btn m-0 ml-auto"
            data-dismiss="modal"
          >
            <i className="fas fa-arrow-right"></i>
            &nbsp; Update User
          </button>
        </div>
      </form>
    </div>
  );
}
